import { Show, type JSX } from "solid-js";

interface HunkNavProps {
  currentIndex: () => number;  // 0-based
  total: () => number;
  onPrev: () => void;
  onNext: () => void;
}

export function HunkNav(p: HunkNavProps): JSX.Element {
  return (
    <Show when={p.total() > 0}>
      <div class="fd-hunk-nav" role="group" aria-label="hunk navigation">
        <button
          type="button"
          class="fd-btn"
          aria-label="previous hunk"
          onClick={p.onPrev}
        >↑</button>
        <span class="fd-counter">{p.currentIndex() + 1} / {p.total()}</span>
        <button
          type="button"
          class="fd-btn"
          aria-label="next hunk"
          onClick={p.onNext}
        >↓</button>
      </div>
    </Show>
  );
}
